import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { useContext, useState } from 'react';
import { TextField } from 'formik-material-ui'
import { Formik, Form, Field } from 'formik';
import { EditIconButton, ProductSearch } from 'components';
import { resolutionsContext, ITicketDefectiveComponent, defectiveComponentSchema } from '../ResolutionsContext';


interface IProps {
    defectiveComponent?: ITicketDefectiveComponent
}


let DefectiveComponentEditor = (props: IProps) => {
    let service = useContext(resolutionsContext);

    let [isOpen, setOpen] = useState(false);


    return (
        <>
            {!props.defectiveComponent &&
                <Button
                    color="secondary"
                    size="small"
                    variant="outlined"
                    onClick={() => setOpen(true)}
                >
                    <AddIcon />&nbsp;Add
                </Button>
            }
            {props.defectiveComponent && <EditIconButton onClick={() => setOpen(true)} />}

            <Dialog open={isOpen} fullWidth maxWidth="sm">
                <DialogTitle disableTypography>
                    <Typography variant="h4">Defective component</Typography>
                </DialogTitle>

                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        ...defectiveComponentSchema.getDefault(),
                        ...props.defectiveComponent
                    }}
                    validationSchema={defectiveComponentSchema}
                    onSubmit={async (values, action) => {
                        let res = await service.saveDefectiveComponent(values);
                        if (res === true) {
                            setOpen(false);
                            action.resetForm();
                        }
                        else
                            action.setSubmitting(false)
                    }}
                >
                    {form =>
                        <Form>
                            <DialogContent style={{ overflowY: 'hidden' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        {!props.defectiveComponent &&
                                            <ProductSearch
                                                label="Defective Component"
                                                margin="dense"
                                                freeSolo={false}
                                                value={{
                                                    value: form.values.productSKU,
                                                    label: `${form.values.productSKU} ${form.values.productDescription}`.trim(),
                                                    brand: form.values.productBrand,
                                                    shortDescription: form.values.productDescription,
                                                    sku: form.values.productSKU,
                                                    hasSerialNumber: false,
                                                    suppliers: []
                                                }}
                                                onChange={(sku: string, brand: string, description: string) => {
                                                    form.setFieldValue('productSKU', sku);
                                                    form.setFieldValue('productBrand', brand);
                                                    form.setFieldValue('productDescription', description);
                                                }}
                                                error={Boolean(form.touched.productSKU && form.errors.productSKU)}
                                                helperText={form.touched.productSKU ? form.errors.productSKU : ''}
                                            />
                                        }
                                        {props.defectiveComponent &&
                                            <Typography gutterBottom>{form.values.productSKU} {form.values.productDescription}</Typography>
                                        }
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Quantity"
                                            name="quantity"
                                            variant="outlined"
                                            type="number"
                                            size="small"
                                            margin="dense"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button color="primary" disabled={form.isSubmitting} onClick={() => setOpen(false)}>Cancel</Button>
                                <Button color="secondary" type="submit" disabled={form.isSubmitting}>Save</Button>
                            </DialogActions>
                        </Form>
                    }
                </Formik>
            </Dialog>
        </>
    )
}

export default DefectiveComponentEditor;